import { Action } from 'redux';
import { initializeState } from 'src/utils/Initial';
import { isType } from 'typescript-fsa';
import * as Actions from '../actions/user';

/**
 * ユーザ画面のState型
 */
export interface IUserState {
	readonly selectUsers: ISelectUserState;
}

/**
 * ユーザ選択画面のState型
 */
export interface ISelectUserState {
	data: Actions.ISelectUser[];
	selectedColumns: number[];
}

/**
 * ユーザ情報画面のState初期値
 */
const initialState: IUserState = {
	selectUsers: {
		data: [],
		selectedColumns: [0, 1, 2, 3, 4, 5],
	},
};

/**
 * ユーザ情報画面用reducer
 * @param state State
 * @param action アクション
 */
const user = (state: IUserState, action: Action) => {
	if (!state) {
		// State初期化処理
		state = initialState;
		state = initializeState(state);
	}
	// 選択用ユーザ情報設定
	if (isType(action, Actions.setSelectUserData)) {
		return {
			...state,
			selectUsers: {
				...state.selectUsers,
				data: action.payload.data,
			},
		};
	}

	// ユーザ選択画面の表示カラム設定
	if (isType(action, Actions.setSelectUserSelectedColumns)) {
		return {
			...state,
			selectUsers: {
				...state.selectUsers,
				selectedColumns: action.payload.selectedColumns,
			},
		};
	}

	return state;
};

export default user;



// WEBPACK FOOTER //
// ./src/reducers/user.ts